module.exports = __webpack_public_path__ + "fonts/dsiccc2020930.3f5d3a0d.ttf";